module.exports = __webpack_public_path__ + "img/08_Howto-5.9119c785.jpg";